class TradePriceCalculationType {
    constructor(serverType) {
        this.serverType = serverType;
    }

    translate(t) {
        return t(`auctions.trade-price-calculation-type.${this.serverType.toLowerCase().replace(/_/g, '-')}`);
    }

    is(tradePriceCalculationType) {
        return tradePriceCalculationType === this;
    }
}

export const AUCTION_PRICE = new TradePriceCalculationType('AUCTION_PRICE');
export const BID_PRICE = new TradePriceCalculationType('BID_PRICE');
export const UNKNOWN = new TradePriceCalculationType('null');

export const getTradePriceCalculationType = (serverType) => {
    let result = null;
    switch (serverType) {
        case 'AUCTION_PRICE':
            result = AUCTION_PRICE;
            break;
        case 'BID_PRICE':
            result = BID_PRICE;
            break;
        default:
            result = UNKNOWN;
    }
    return result;
};

export const getAllTradePriceCalculationTypes = () => [
    AUCTION_PRICE,
    BID_PRICE,
];
